import type {ReactElement} from 'react';
import React, {useEffect} from 'react';
import {setMediaType} from '@Panels/record-image-and-video-panel/record-image-and-video-panel-reducer';
import {ImageAndVideoRecorderStatus, RecorderMediaType} from '@Panels/record-image-and-video-panel/record-image-and-video.types';
import {Tabs, TabSliderType, TabsThemes} from '@Components/tabs';
import {deleteTabStateForId} from '@Components/tabs/tabs-reducer';
import {useAppDispatch, useAppSelector} from '@/hooks';
import styles from './image-and-video-toggle.module.scss';

const IMAGE_AND_VIDEO_TOGGLE_TABS_ID = 'image-and-video-toggle';

interface ImageAndVideoToggleProps {
  className?: string;
}

export function ImageAndVideoToggle({className = ''}: ImageAndVideoToggleProps): ReactElement | null {
  const dispatch = useAppDispatch();

  const recorderStatus = useAppSelector((state) => {
    return state.recordImageAndVideoPanel.imageAndVideoRecorderStatus;
  });

  const mediaType = useAppSelector((state) => {
    return state.recordImageAndVideoPanel.mediaType;
  });

  useEffect(() => {
    return () => {
      dispatch(deleteTabStateForId(IMAGE_AND_VIDEO_TOGGLE_TABS_ID));
    };
  }, []);

  return (
    <div className={`${styles.container} ${className}`}>
      <Tabs
        id={IMAGE_AND_VIDEO_TOGGLE_TABS_ID}
        onTabClick={(tabKey) => {
          if (tabKey === RecorderMediaType.IMAGE.toString()) {
            dispatch(setMediaType({mediaType: RecorderMediaType.IMAGE}));
          } else {
            dispatch(setMediaType({mediaType: RecorderMediaType.VIDEO}));
          }
        }}
        selectedTab={mediaType}
        shouldTabsHaveEqualWidth
        sliderType={TabSliderType.SLIDER_BLOCK}
        tabItems={[
          {
            className: 'flex-center',
            textClassName: 'body-xs-bold',
            disabled: recorderStatus === ImageAndVideoRecorderStatus.RECORDING,
            disableSelection: recorderStatus === ImageAndVideoRecorderStatus.RECORDING,
            preTitleContent: <i className={`icon size-icon-16 icon-camera ${styles.tabsIcon}`} />,
            tabKey: RecorderMediaType.IMAGE,
            text: window.i18next.t('pmwjs_image'),
          },
          {
            className: 'flex-center',
            textClassName: 'body-xs-bold',
            disabled: recorderStatus === ImageAndVideoRecorderStatus.RECORDING,
            disableSelection: recorderStatus === ImageAndVideoRecorderStatus.RECORDING,
            preTitleContent: <i className={`icon size-icon-16 icon-videocam ${styles.tabsIcon}`} />,
            tabKey: RecorderMediaType.VIDEO,
            text: window.i18next.t('pmwjs_video'),
          },
        ]}
        theme={TabsThemes.PRIMARY_LIGHT}
      />
    </div>
  );
}
